
import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator';
import _shuffle from 'lodash/shuffle';
import _cloneDeep from 'lodash/cloneDeep';
import Medias from '@/@next/services/Medias';
import { messages } from '@/@next/i18n';
import { TimelineContentData, TimelineContentEventData } from '@/@types/graphql';
import CTimelineFullScreenEvent from './TimelineFullScreenEvent.vue'
import CTimelineFullScreenSlider from './TimelineFullScreenSlider.vue';
import CTimelineFullScreenImageSlider from './TimelineFullScreenImageSlider.vue';
import CTimelineFullScreenGame from './TimelineFullScreenGame.vue'
import cloneDeep from 'lodash/cloneDeep';

export interface GameEvent extends TimelineContentEventData {
  goodImageId: string | null
  result: boolean | undefined
}

const config = {
  name: 'c-timeline-full-screen',
  i18n: { messages },
  components: {
    CTimelineFullScreenEvent,
    CTimelineFullScreenSlider,
    CTimelineFullScreenImageSlider,
    CTimelineFullScreenGame
  }
};

@Component(config)
export default class CTimelineFullScreen extends Mixins(Medias) {
  @Prop({ type: Object, required: true }) timeline!: TimelineContentData
  @Prop({ type: Number, required: false, default: 0 }) current!: number
  @Prop({ type: Boolean, required: true}) displayAsGame!: boolean

  localCurrent: number = this.current
  gameEvents: TimelineContentEventData[] = []
  gameStarted: boolean = false
  lastSelectedEventId: string | null = null
  gameIsCompleted: boolean = false

  mounted () {
    this.localCurrent = this.current
    this.gameEvents = this.events.map((e: TimelineContentEventData) =>
      ({ ...e, image: null, goodImageId: e.image?.id, result: undefined }))
    if (this.displayAsGame) this.select(0)
  }

  get title () {
    return this.timeline?.i18n?.title?.value || null;
  }

  get events () {
    return this.timeline?.events || [];
  }

  get event () {
    if (this.displayAsGame) return this.gameEvents[this.localCurrent]
    return this.events[this.localCurrent];
  }

  // get isGame () {
  //   return this.timeline.options.isGame
  // }

  // get isPlayed () {
  //   // TODO: FIND this value in cookies
  //   return this.gameIsCompleted;
  // }

  // get displayAsGame () {
  //   return this.isGame && !(this.timeline.options.gameToContent && this.isPlayed)
  // }

  get instruction () {
    return this.timeline.i18n.instruction?.value.html
  }

  select (i: number) {
    this.$emit('select', i)
    this.localCurrent = i;
  }

  selectImageFromGame (id: string) {
    const event = this.events.find((event) => event.id === id)
    if (!event) return
    // this.gameEvents[this.localCurrent].image = this.events[index].image
    Vue.set(this.gameEvents[this.localCurrent], 'image', event.image)
    this.lastSelectedEventId = id
    // this.select(index)
  }

  removeCurrentImage () {
    Vue.set(this.gameEvents[this.localCurrent], 'image', null)
  }

  startGame () {
    this.gameStarted = true
  }

  completed () {
    this.gameIsCompleted = true
    setTimeout(() => {
      this.$emit('completed')
    }, 1000)
  }

}
